/**
 * One lazy pdf.js instance for the app. pdfjs-dist is heavy, so it is
 * imported on first use and the worker is wired once. (The SWPPP editor
 * carries its own copy of this for historical reasons.)
 */
let pdfjsPromise: Promise<typeof import('pdfjs-dist')> | null = null;

export async function loadPdfjs() {
  if (!pdfjsPromise) {
    pdfjsPromise = (async () => {
      const [lib, worker] = await Promise.all([
        import('pdfjs-dist'),
        import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
      ]);
      lib.GlobalWorkerOptions.workerSrc = worker.default;
      return lib;
    })();
  }
  return pdfjsPromise;
}
